import { Observable } from "rxjs";
import { inject, injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { SurveyAnswer } from "src/shared/models";
import { GenericSuccessResponse } from "src/infra/http/types";

@injectable()
export class SurveysRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getAnsweredSurveys(): Observable<object[]> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            window.userIdentity || "",
            "MEP"
        );
        return this.http.getJSON<object[]>(SurveysRepository.getUrl(), {
            isPublicRequest: false,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }

    @autoBind
    answerSurvey(payload: SurveyAnswer): Observable<GenericSuccessResponse> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            window.userIdentity || "",
            "MEP"
        );
        return this.http.post<GenericSuccessResponse>(
            SurveysRepository.getUrl(),
            {
                data: payload.toJson(),
                isPublicRequest: false,
                customHeader: {
                    ...this.http.httpUtils.getBaseHeaders(),
                    ...headers,
                },
            }
        );
    }

    static getUrl(): string {
        return "insureds/me/surveys";
    }
}
